// src/app/redux/actions/workflowActions.js

export const FETCH_WORKFLOWS_REQUEST = 'FETCH_WORKFLOWS_REQUEST';
export const FETCH_WORKFLOWS_SUCCESS = 'FETCH_WORKFLOWS_SUCCESS';
export const FETCH_WORKFLOWS_FAIL = 'FETCH_WORKFLOWS_FAIL';

export const SAVE_WORKFLOW_REQUEST = 'SAVE_WORKFLOW_REQUEST';
export const SAVE_WORKFLOW_SUCCESS = 'SAVE_WORKFLOW_SUCCESS';
export const SAVE_WORKFLOW_FAIL = 'SAVE_WORKFLOW_FAIL';

export const DELETE_WORKFLOW_REQUEST = 'DELETE_WORKFLOW_REQUEST';
export const DELETE_WORKFLOW_SUCCESS = 'DELETE_WORKFLOW_SUCCESS';
export const DELETE_WORKFLOW_FAIL = 'DELETE_WORKFLOW_FAIL';

export const fetchWorkflows = (companyId) => ({
    type: FETCH_WORKFLOWS_REQUEST,
    payload: companyId,
});

export const saveWorkflow = (workflow) => ({
    type: SAVE_WORKFLOW_REQUEST,
    payload: workflow,
});

export const deleteWorkflow = (id) => ({
    type: DELETE_WORKFLOW_REQUEST,
    payload: id,
});
